<template>
  <div class="d-flex align-items-center justify-content-around">
    <button
      :disabled="!$props.previousQuote"
      class="btn mr-3 bg-orange text-white"
      @click="
        paginate(
          $props.previousQuote.quoteId,
          $props.previousQuote.quoteIdentifier
        )
      "
    >
      <i class="fas fa-angle-left mr-1"></i>
      <span class="text-uppercase mt-2">Anterior</span>
    </button>
    <button
      :disabled="!$props.nextQuote"
      class="btn mr-3 bg-orange text-white"
      @click="
        paginate($props.nextQuote.quoteId, $props.nextQuote.quoteIdentifier)
      "
    >
      <span class="text-uppercase mt-2">Próxima</span>
      <i class="fas fa-angle-right ml-1"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Paginate',
  props: {
    routeNameToPush: {
      type: String,
      required: true,
    },
    nextQuote: {
      type: Object,
      required: true,
    },
    previousQuote: {
      type: Object,
      required: true,
    },
  },
  methods: {
    paginate(quoteId, quoteIdentifier) {
      if (quoteId) {
        this.$router.push({
          name: this.routeName,
          params: { id: quoteId, identifier: quoteIdentifier },
        });
      }
    },
  },
};
</script>

<style scoped>
.actions span {
  display: block;
}

.actions i {
  color: var(--orange-primary);
  font-size: 56px;
  text-shadow: 0px 10px 10px var(--alpha-orange);
}
</style>
